// End trip, for someone not shopping in it: the trip was forgotten (left open
// on a watch, say) and blocks everyone else's Start shopping. Ending is
// Finish trip for everyone (045's finish_trip lets any member), so it asks
// first — Keep it going is the safe answer — and says how live the trip looks
// (lib/sharedTrip.ts endTripText). No Undo: the shopper gets the usual
// "… finished the trip" note with Keep shopping.

interface Props {
  title: string
  facts: string
  onEnd: () => void
  onKeep: () => void
}

export function EndTripDialog({ title, facts, onEnd, onKeep }: Props) {
  return (
    <div className="ml-shopping__ask" role="alertdialog" aria-modal="true" aria-labelledby="ml-end-title"
      aria-describedby="ml-end-text">
      <h2 id="ml-end-title" className="ml-display ml-sheet-title">{title}</h2>
      <p id="ml-end-text" className="ml-caption">
        {facts}. The basket goes to the history and the trip ends for everyone.
      </p>
      <button type="button" className="ml-btn ml-btn--primary ml-btn--wide" onClick={onKeep}>Keep it going</button>
      <button type="button" className="ml-btn ml-btn--secondary ml-btn--wide" onClick={onEnd}>End trip</button>
    </div>
  )
}
